module.exports = __webpack_public_path__ + "public/img/tdjc.bbc7883c.png";